import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Form,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import Select from "react-select";
// import "../style.css";

function CreateCategory({ setPage }) {
  const [category, setCategory] = React.useState("");

  const continueButton = () => {
    // window.location.href = "/admin/move-money/confirm";
  };

  return (
    <>
      <div className="content paybill">
        <Row>
          <Col md="7">
            <Card>
              <CardHeader className="paybill-header">
                <h5 className="title ml-2">Create interests</h5>
              </CardHeader>
              <CardBody>
                <Form>
                  <Row>
                    <Col className="pr-1" md="6">
                      <FormGroup>
                        <label>interests Name</label>
                        <Input placeholder="interests Name" type="text" />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      md="6"
                      className="footer-buttons d-flex justify-content-start">
                      <Button
                        onClick={() => setPage("1")}
                        color="secondary"
                        size="md"
                        className="btn-round mr-2 cancel-button">
                        Cancel{" "}
                      </Button>

                      <Button
                        onClick={continueButton}
                        color="primary"
                        size="md"
                        className="btn-round">
                        Ok
                      </Button>
                    </Col>
                    <Col md="6"></Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default CreateCategory;
